/*
XXX_JSREFACTOR_XXX
todo @JSREFACTOR
    - write tests for this and refactor if needed
*/
(function () {
    const pageDownloads = document.querySelector('[data-page-downloads]');
    if (pageDownloads) {
        const upgradeDisplayClass = 'js-upgrade-warning-display';

        let closeUpgradeWarning = () => {
            const closeButtons = pageDownloads.querySelectorAll(
                '[data-page-downloads=close-button]'
            );
            closeButtons.forEach(closeBtn => {
                closeBtn.addEventListener('click', () => {
                    closeBtn.parentElement.classList.remove(upgradeDisplayClass);
                });
            });
        };

        let openUpgradeWarning = () => {
            const downloadButtons = pageDownloads.querySelectorAll(
                '[data-page-downloads=upgrade-button]'
            );
            downloadButtons.forEach(openBtn => {
                openBtn.addEventListener('click', () => {
                    if (
                        !openBtn.nextElementSibling.classList.contains(
                            upgradeDisplayClass
                        )
                    )
                        openBtn.nextElementSibling.classList.add(upgradeDisplayClass);
                });
            });
        };

        let init = () => {
            openUpgradeWarning();
            closeUpgradeWarning();
        };

        return {
            init,
        };
    }
})().init();
